import { debounce } from 'lodash';
import { Point } from '@sierralabs/workflow';

import { Connector, Entity } from '.';

export class EntityManager {
  protected readonly entities: Entity[] = [];

  constructor(
    readonly rootEl: HTMLElement,
    private readonly scrollEl?: HTMLElement | null
  ) {}

  get offset(): Point {
    const { offsetLeft = 0, offsetTop = 0 } = this.rootEl || {};
    return { x: offsetLeft, y: offsetTop };
  }

  get scrollOffset(): Point {
    const { scrollLeft = 0, scrollTop = 0 } = this.scrollEl || {};
    return { x: scrollLeft, y: scrollTop };
  }

  getEntity(entityId: string): Entity | undefined {
    return this.entities.find((entity: Entity) => entity.id === entityId);
  }

  addEntity(entityId: string): Entity | undefined {
    const existingEntity: Entity | undefined = this.getEntity(entityId);
    if (existingEntity) {
      return existingEntity;
    }

    const entity: Entity = new Entity(this, entityId);
    this.entities.push(entity);
    return entity;
  }

  getConnectors(source?: Entity, target?: Entity | null): Connector[] {
    const connectors: Connector[] = ([] as Connector[]).concat(
      ...this.entities.map((entity: Entity) => entity.connectors)
    );
    return connectors.filter((connector: Connector) => {
      return (
        (!source || connector.source === source) &&
        (typeof target === 'undefined' || connector.target === target)
      );
    });
  }

  runObserverCallbacks(exclude?: Connector) {
    for (const connector of this.getConnectors()) {
      if (exclude === connector) {
        continue;
      }
      connector.runObserverCallback();
    }
  }

  readonly runDebouncedObserverCallbacks = debounce((exclude?: Connector) => {
    this.runObserverCallbacks(exclude);
  }, 5);
}
